var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard"}},[_c('PageHeader',{attrs:{"title":"Dashboard"}}),_c('UnderContruction',{staticClass:"under-contruction"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }